import classNames from 'classnames';
import React, { Component } from 'react';

import LazyBlockHoc from './LazyBlockHoc';
import MarkdownText from '../MarkdownText';

import './ImageBlock.css';

const EXPANDED_CLASS = 'ImageBlock__img--expanded';

class Img extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
    this.setup = this.setup.bind(this);
    this.cleanup = this.cleanup.bind(this);
  }

  setup() {
    this.el.classList.add(EXPANDED_CLASS);
    this.el.style.maxWidth = `calc(${window.innerWidth}px - 1.5rem)`;
    document.body.addEventListener('click', this.cleanup);
  }

  cleanup(evt) {
    // If the user clicks on the image, the body click handler will also
    // fire. If that's the case, we should ignore this cleanup since another
    // one will be coming from the onClick method below.
    if (evt && evt.target === this.el) {
      return;
    }

    document.body.removeEventListener('click', this.cleanup);

    this.el.classList.remove(EXPANDED_CLASS);
    this.el.style.maxWidth = '';
  }

  onClick(evt) {
    if (this.el.classList.contains(EXPANDED_CLASS)) {
      this.cleanup();
    } else {
      this.setup();
    }
  }

  render() {
    const { alt, ...additionalProps} = this.props;
    return (
      <img
        ref={el => (this.el = el)}
        className="ImageBlock__img"
        onClick={this.onClick}
        alt={alt}
        {...additionalProps}
      />
    );
  }
}

class ImageBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      numLoaded: 0,
    };
  }

  render() {
    const { boundingRef, imgs, isVisible } = this.props;

    if (!imgs || !imgs.length) return null;

    return (
      <div
        className={classNames('ImageBlock', {
          'ImageBlock--loaded': this.state.numLoaded === imgs.length,
        })}
        ref={boundingRef}
      >
        {imgs.map(({ src, caption, style, width, height }) => (
          <div className="ImageBlock__block" key={src}>
            <div className="ImageBlock__wrapper">
              <div
                style={{
                  paddingTop: `${100 * height / width}%`,
                }}
                className="ImageBlock__placeholder"
              >
                <div className="ImageBlock__placeholder-image">
                  image not ready yet
                </div>
              </div>
              {isVisible && (
                <Img
                  alt={caption}
                  src={`${process.env.PUBLIC_URL}/${src}`}
                  onLoad={() => (
                    this.setState({ numLoaded: this.state.numLoaded + 1 })
                  )}
                />
              )}
            </div>
            {caption && (
              <div className="ImageBlock__caption">
                <MarkdownText text={caption} />
              </div>
            )}
          </div>
        ))}
      </div>
    );
  }
}

export default LazyBlockHoc(ImageBlock);



// WEBPACK FOOTER //
// ./src/components/timeline/ImageBlock.js